/**
 *
 * Commission report widget container
 * Fetch data & render spinner/error/content depending on state
 *
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import businessChangeModule from 'containers/App/data/endpoints/businessChangeByMonth';

import messages from './messages';
import { defaultLayout } from 'containers/widgets/Widget/propTypes';

import Widget from 'containers/widgets/Widget/Widget';
import BusinessChange from './BusinessChange';
import { DEFAULT_CHANGE_RANGE } from './constants';
import { calculateBookingDatesFromRange, getStayDatesRange } from './utils';

const BusinessChangeWrapper = ({
    propertyId,
    currency,
    layout = defaultLayout,
    isFlex = true,
    isDraggable = false,
    dashboardVersion = false,
}) => {
    const dispatch = useDispatch();
    const businessChange = useSelector(businessChangeModule.selectors.selectState);

    const [range, setRange] = useState(DEFAULT_CHANGE_RANGE);

    const stayDateRange = getStayDatesRange();
    const bookingDateRange = calculateBookingDatesFromRange(range);
    const filters = {
        ...stayDateRange,
        ...bookingDateRange,
    };

    const changeRange = (newRange) => {
        setRange(newRange);
    };

    const fetchData = () => {
        dispatch(businessChangeModule.actions.resetState());
        const { startDate, endDate, minBookingDatetime, maxBookingDatetime } = filters;
        dispatch(
            businessChangeModule.actions.fetch(propertyId, startDate, endDate, minBookingDatetime, maxBookingDatetime),
        );
    };

    useEffect(() => {
        fetchData();
        return () => {
            dispatch(businessChangeModule.actions.resetState());
        };
    }, [propertyId, range]);

    return (
        <Widget
            layout={layout}
            state={businessChange}
            titleMessage={dashboardVersion ? messages.titleDashboard : messages.title}
            retry={fetchData}
            manageFetchingState={false}
            isFlex={isFlex}
            isDraggable={isDraggable}
        >
            <BusinessChange
                data={businessChange.data}
                isFetching={businessChange.fetching}
                currency={currency}
                dashboardVersion={dashboardVersion}
                onChangeBookingDateRange={changeRange}
            />
        </Widget>
    );
};

export default BusinessChangeWrapper;
